import { Box, Chip, TableCell, TableRow, Tooltip, Typography } from '@mui/material';
import CheckIcon from '@mui/icons-material/CheckCircle';
import CloseIcon from '@mui/icons-material/Cancel';
import InfoIcon from '@mui/icons-material/InfoOutlined';
import XCheckBoxInput from '../../../../../../components/inputs/XCheckBoxInput';

export type TemplateTableRowProps = {
  key: string;
  title: string;
  dataType: string;
  isVerifiable: boolean;
  verificationExplanation: string;
  captureFieldName: string;
  verifyFieldName: string;
  requiredFieldName: string;
  onCheckboxChange?: (fieldName: string, isChecked: boolean) => void;
};

const TemplateTableRow = ({
  title,
  dataType,
  isVerifiable,
  verificationExplanation,
  captureFieldName,
  verifyFieldName,
  requiredFieldName,
  onCheckboxChange
}: TemplateTableRowProps) => {

  return (
        <TableRow>
            <TableCell>
                <Typography variant="h6">{title}</Typography>
            </TableCell>
            <TableCell>
                <Typography variant="h6">{dataType}</Typography>
            </TableCell>
            <TableCell>
                <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                    }}
                >
                    <Chip
                        icon={isVerifiable ? <CheckIcon color="success"/> : <CloseIcon color="error"/>}
                        variant="filled"
                        size="small"
                        label={isVerifiable ? 'YES' : 'NO'}
                        sx={{ mr: 1 }}
                    />
                    <Tooltip
                        title={verificationExplanation}
                        arrow
                    >
                        <InfoIcon
                            color="info"
                            fontSize="small"
                        />
                    </Tooltip>
                </Box>
            </TableCell>
            <TableCell>
                <XCheckBoxInput
                    label=""
                    name={captureFieldName}
                />
            </TableCell>
            <TableCell>
                <XCheckBoxInput
                    label=""
                    name={verifyFieldName}
                    disabled={!isVerifiable}
                    onChange={(e) => onCheckboxChange(verifyFieldName, e.target.checked)}
                />
            </TableCell>
            <TableCell>
                <XCheckBoxInput
                    label=""
                    name={requiredFieldName}
                />
            </TableCell>
        </TableRow>
  );
};

export default TemplateTableRow;
